import React, {Suspense} from "react";
import {Redirect, Route, Switch,} from "react-router-dom";
import {ThemeProvider} from "@material-ui/core/styles";

import 'react-medium-image-zoom/dist/styles.css';
import "./App.css";
import {SnackbarProvider} from "./ui/SnackbarProvider";
import {Box, CircularProgress} from "@material-ui/core";
import {theme} from "./theme";
import {initAnalytics} from "./lib/analytics";
import {useStore} from "effector-react";
import {$auth} from "./pages/Auth/model/authModel";

const AuthPage = React.lazy(() => import("./pages/Auth/AuthPage"));
const OrderPage = React.lazy(() => import("./pages/Order"));

initAnalytics();

export const App = () => {
    const auth = useStore($auth);
    const isAuth = Boolean(auth.isAuthenticated);

    return (
        <ThemeProvider theme={theme}>
            <SnackbarProvider>
                <Suspense
                    fallback={
                        <Box
                            height="100vh"
                            width="100vw"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <CircularProgress color="primary"/>
                        </Box>
                    }
                >
                    <Switch>
                        {isAuth ? (
                            <>
                                <Route path="/order" component={OrderPage}/>
                                <Redirect to="/order"/>
                            </>
                        ) : (
                            <>
                                <Route path="/login" component={AuthPage}/>
                                <Redirect to="/login"/>
                            </>
                        )}
                    </Switch>


                </Suspense>
            </SnackbarProvider>
        </ThemeProvider>
    );
};
